export const COURSE_IMAGES = {
  zeroToFour: '/curso-0a4-hero.jpg',
  fourToTwenty: '/curso-4a20-hero.jpg',
  nightWeaning: '/destete-nocturno-hero.jpg',
  newborn: '/nacimiento-bebe-hero.jpg',
  firstFoods: '/primeros-alimentos-hero.jpg'
};
